export const CLICK = 'CLICK';
export const LOAD_LATEST_ARTICLES = 'LOAD_LATEST_ARTICLES';
export const LOAD_LATEST_ARTICLES_SUCCESS = 'LOAD_LATEST_ARTICLES_SUCCESS';
export const LOAD_LATEST_ARTICLES_ERROR = 'LOAD_LATEST_ARTICLES_ERROR';
